export const es = {
  main: {
    color_hex: 'Color en notación hexadecimal, comienza con #',
    language: 'español',
    restricted_field_name: 'Este nombre de campo está reservado y no se puede usar',
    asset_type_required: 'Seleccione al menos un tipo de activo o haga el campo global',
    searchbar: 'Buscar (mín. 3 caracteres)',
    title: 'Admin',
    logout: 'Cerrar sesión',
    english: 'inglés',
    dutch: 'holandés',
    french: 'francés',
    spanish: 'español',
    danish: 'danés',
    italian: 'italiano',
    romanian: 'rumano',
    norwegian: 'noruego',
    german: 'alemán',
    drop_image: 'Suelta tu imagen aquí',
  },
  ra: {
    tree: {
      add_child_node: 'Añadir subcategoría',
      add_node_after: 'Añadir categoría después',
      add_node_before: 'Añadir categoría para',
      close: 'Cerrar',
      expand: 'Abrir',
    },
  },
  resources: {
    categories: {
      name: 'Categoria |||| Categorias',
      fields: {
        name: 'Nombre de categoria',
      },
    },
    users: {
      name: 'Usuario |||| Usuarios',
      fields: {
        category: 'Categoria',
        connection: 'Conexión',
        email: 'Correo electrónico',
        familyName: 'Apellido',
        firstName: 'Nombre',
        language: 'Idioma',
        userRoles: 'Roles',
      },
    },
    priorities: {
      name: 'Prioridad |||| Prioridades',
    },
    branding: {
      name: 'Logo',
    },
    invitations: {
      name: 'Invitación |||| Invitaciones',
      fields: {
        email: 'Correo electrónico',
      },
    },
    'asset-types': {
      name: 'Tipo de activo |||| Tipos de activos',
      fields: {
        name: 'Nombre',
      },
    },
    'asset-statuses': {
      name: 'Estado del activo |||| Estados del activo',
      fields: {
        name: 'Nombre',
      },
    },
    'asset-custom-fields': {
      name: 'Campo personalizado del activo |||| Campos personalizados del activo',
      fields: {
        name: 'Nombre',
        globalField: 'Global (todos los tipos de activos)',
        assetTypeIds: 'Tipos de activos',
      },
    },
  },
}
